import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    DialogShow: false,
    DialogData: {
      title: '',
      content: '',
      confirmText: '',
      cancelText: '',
      confirmCb: () => { }
    },
    LoadingShow: false,
    LoadingText: "loading...",
    ToastShow: false,
    ToastText: "",
    EmptyMaskShow: false,
    androidToken: null,
    showShare: false,
    userId: "",
    trafficTag: "",
    appVersion: "",
    clientSource: "",
    inviteFissionChoice: "" //
  },
  mutations: {
    ToastShow: function (state, text) {
      state.ToastShow = true;
      state.ToastText = text;
    },
    ToastHide: function (state) {
      state.ToastShow = false;
    },
    LoadingShow: function (state) {
      state.LoadingShow = true;
    },
    LoadingHide: function (state) {
      state.LoadingShow = false;
    },
    DialogShow: function (state, data) {
      state.DialogShow = true;
      state.DialogData = data
    },
    DialogHide: function (state) {
      state.DialogShow = false;
    },
    SetAndroidToken: function (state, token) {
      state.androidToken = token;
    },
    SetUserId: function (state, userId) {
      state.userId = userId;
    },
    SetTrafficTag: function (state, trafficTag) {
      state.trafficTag = trafficTag;
    },
    SetAppVersion: function (state, appVersion) {
      state.appVersion = appVersion;
    },
    SetClientSource: function (state, clientSource) {
      state.clientSource = clientSource;
    },
    EmptyMaskShow: function (state) {
      state.EmptyMaskShow = true;
    },
    EmptyMaskHide: function (state) {
      state.EmptyMaskShow = false;
    },
    SetInviteFissionChoice: function (state, choice) {
      state.inviteFissionChoice = choice;
    },
    ShareShow: function (state) {
      state.showShare = !state.showShare;
    }
  },

  //actionspromise async await
  actions: {
    // ToastShow: function (context, payload) {
    //   return new Promise(resolve => {
    //     setTimeout(() => {
    //       context.commit("ToastShow", payload);
    //       resolve();
    //     }, 2000);
    //   });
    // }
    //
    //await this.$store.dispatch("ToastShow", " ");
    SetAndroidToken: function (context, payload) {
      return new Promise(resolve => {
        context.commit("SetAndroidToken", payload);
        setTimeout(() => {
          return resolve();
        }, 0);
      });
    },
    SetUserId: function (context, payload) {
      return new Promise(resolve => {
        context.commit("SetUserId", payload);
        setTimeout(() => {
          return resolve();
        }, 0);
      });
    },
    SetTrafficTag: function (context, payload) {
      return new Promise(resolve => {
        context.commit("SetTrafficTag", payload);
        setTimeout(() => {
          return resolve();
        }, 0);
      });
    },
    SetAppVersion: function (context, payload) {
      return new Promise(resolve => {
        context.commit("SetAppVersion", payload);
        setTimeout(() => {
          return resolve();
        }, 0);
      });
    },
    SetClientSource: function (context, payload) {
      return new Promise(resolve => {
        context.commit("SetClientSource", payload);
        setTimeout(() => {
          return resolve();
        }, 0);
      });
    },
    SetInviteFissionChoice: function (context, payload) {
      return new Promise(resolve => {
        context.commit("SetInviteFissionChoice", payload);
        return resolve();
      });
    }
  },
  //state
  getters: {
    nameInfo (state) {
      return ":" + state.name;
    },
    fullInfo (state, getters) {
      return getters.nameInfo + ":" + state.age;
    }
  },
  modules: {}
});
